import { z } from 'zod';

export const userRoleSchema = z.object({
    user_role_name: z.string({
        message : "User Role Name is required"
    }).nonempty({
         message : "User Role Name is required"
    }),
    description: z.string().nullable(),
});
